// @flow
import {all, fork} from 'redux-saga/effects';
import {addMoneySaga} from './AddMoney';
import {saga as agreementsSaga} from './Agreements';
import {loginSaga} from './Authentication';
import {availableOptionSaga} from './AvailableOption';
import {saga as billingAddressSaga} from './BillingAddress';
import {saga as fetchReferralBonusesSaga} from './Bonuses';
import {customerSaga} from './Customer';
import {saga as dashboardSaga} from './Dashboard';
import {deliveryResourceSaga} from './DeliveryResource';
import {filesSaga} from './Files';
import {saga as internationalSaga} from './International';
import {saga as legalDocumentsSaga} from './LegalDocuments';
import {saga as localizationSaga} from './Localization';
import {navigationSaga} from './Navigation';
import {saga as newOfferSaga} from './NewOffer';
import {saga as nextPlanSaga} from './NextPlan';
import {notificationSaga} from './Notification';
import {saga as phoneLinesSaga} from './PhoneLines';
import {saga as promoProductsSaga} from './PromoProducts';
import {getRioSaga} from './Rio';
import {signUpSaga} from './SignUp';
import {subscriptionSaga} from './Subscription';
import {saga as subscriptionsSaga} from './Subscriptions';
import {saga as suspendOrTerminate} from './SuspendSwapTerminate';
import {saga as timelineSaga} from './Timeline';
import {saga as topUpsSaga} from './TopUps';
import {saga as usageSaga} from './Usage';
import {saga as vouchersSaga} from './Voucher';
import {saga as voucherSaga} from './VoucherAddMoney';
import {saga as walletSaga} from './Wallet';
import {saga as esimSaga} from './ESim';

export default function* rootSaga(): Generator<*, *, *> {
  yield all([
    fork(addMoneySaga),
    fork(agreementsSaga),
    fork(availableOptionSaga),
    fork(billingAddressSaga),
    fork(customerSaga),
    fork(dashboardSaga),
    fork(deliveryResourceSaga),
    fork(fetchReferralBonusesSaga),
    fork(filesSaga),
    fork(internationalSaga),
    fork(getRioSaga),
    fork(legalDocumentsSaga),
    fork(localizationSaga),
    fork(loginSaga),
    fork(navigationSaga),
    fork(newOfferSaga),
    fork(nextPlanSaga),
    fork(notificationSaga),
    fork(phoneLinesSaga),
    fork(promoProductsSaga),
    fork(signUpSaga),
    fork(subscriptionSaga),
    fork(subscriptionsSaga),
    fork(suspendOrTerminate),
    fork(timelineSaga),
    fork(topUpsSaga),
    fork(usageSaga),
    fork(voucherSaga),
    fork(walletSaga),
    fork(vouchersSaga),
    fork(esimSaga),
  ]);
}
